module.exports = __webpack_public_path__ + "static/media/vpf_logo.04a1578a.png";